import React, { useState, useEffect } from "react";
import config from "../../config";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

//components
import PageTitle from "../../components/PageTitle/PageTitle";
import { CircularProgress, TextField } from "@material-ui/core";
import Modal from "../modals/Modal";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  IconButton,
} from "@material-ui/core";
import SnackbarMessage from "../modals/SnackbarMessage";
import {
  CloudDownload as Download,
} from "@material-ui/icons";

// styles
import useStyles from "./styles";
import useStylesTable from "../products/styles";

const EgressReport = () => {
  const classes = useStyles();
  const classesTable = useStylesTable();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);

  const [sales, setSales] = useState([]);
  const [today, setToday] = useState(null);
  const [dateOne, setDateOne] = useState(null);
  const [dateTwo, setDateTwo] = useState(null);
  const [totalEgress, setTotalEgress] = useState(0);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  useEffect(() => {
    setIsLoading(true);
    const today = new Date();
    var day = "";

    if (today.getDate() < 10) {
      day = '0' + today.getDate();
    } else {
      day = today.getDate();
    }

    if ((today.getMonth() + 1) < 10) {
      var newDateInputFormat = day + '/0' + (today.getMonth() + 1) + '/' + today.getFullYear();
      setToday(newDateInputFormat);

      const body = {
        dateOne: newDateInputFormat
      };

      fetchEgress(body);
    } else {
      var newDateInputFormat = day + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
      setToday(newDateInputFormat);

      const body = {
        dateOne: newDateInputFormat
      };

      fetchEgress(body);
    }

    setIsLoading(false);
  }, []);

  function currencyFormat(num) {
    return '$ ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const handleToClose = (event, reason) => {
    if ("clickaway" == reason) return;
    setShowSnackbar(false);
  };

  const fetchEgress = async (body) => {
    fetch(baseUrl + "egressByDate",
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
        body: JSON.stringify(body)
      }).then(response => response.json())
      .then(data => {
        if (data.status == "Ok") {
          setSales(data.content);
          setTotalEgress(data.total);
        } else {
          setShowModal(true);
        }
      }).catch(error => null);
  }

  const onChangeDateOne = (e) => {
    setDateOne(e.target.value);
  }

  const onChangeDateTwo = (e) => {
    setDateTwo(e.target.value);
  }

  const onClickToday = (e) => {
    const body = {
      dateOne: today
    };

    fetchEgress(body);
  }

  const onClickRange = (e) => {
    const body = {
      dateOne: dateOne, dateTwo: dateTwo
    };

    fetchEgress(body);
  }

  const onClickSave = () => {
    const pdf = new jsPDF();
    var totalPagesExp = '{total_pages_count_string}';

    pdf.text('Reporte de egresos - KochulGym', 14, 20);

    pdf.autoTable({
      head: [['Fecha y hora', 'Concepto', 'Total']],
      columns: [
        { dataKey: 'creationDate', header: 'Fecha y hora' },
        { dataKey: 'name', header: 'Concepto' },
        { dataKey: 'total', header: 'Total' },
      ],
      body: bodyRows(),
      startY: 30,
      didDrawPage: function (data) {
        // Footer
        var str = 'Página ' + pdf.internal.getNumberOfPages()
        // Total page number plugin only available in jspdf v1.0+
        if (typeof pdf.putTotalPages === 'function') {
          str = str + ' de ' + totalPagesExp
        }
        pdf.setFontSize(10);

        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
        var pageSize = pdf.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        pdf.text(str, data.settings.margin.left, pageHeight - 10)
      },
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof pdf.putTotalPages === 'function') {
      pdf.putTotalPages(totalPagesExp)
    }
    pdf.save("Egresos.pdf");
  }
  
  function bodyRows() {
    var body = [];
    sales.map(({ name, creationDate, creationTime, total }) => (
      body.push({
        name: name,
        creationDate: creationDate + " " + creationTime,
        total: currencyFormat(Number(total)),
      })
    ));

    body.push({
      name: "",
      creationDate: "Total:",
      total: currencyFormat(Number(totalEgress)),
    });
    return body
  }

  return (
    <>
      <div>
        {showModal ? (
          <Modal
            isOpen={showModal}
            closeModal={closeModalLogin}
          />
        ) : (
          <></>
        )}

        <SnackbarMessage
          showSnackbar={showSnackbar}
          messageSnackbar={messageSnackbar}
          handleToClose={handleToClose}
          isError={errorSnackbar}
        />

        {isLoading ? (
          <CircularProgress size={26} className={classes.loginLoader} />
        ) : (
          <div style={{ height: "100%" }}>
            <PageTitle title="Reporte de egresos" />

            <div className={classesTable.divCardSaleDos}>

              <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "25px", textAlign: "justify", backgroundColor: "#fff", borderRadius: "4px" }}>
                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "20%" }}>
                    <text style={{ color: "#000", marginLeft: "24px" }}>Fecha:</text>
                    <button
                      className={classes.enableButtonDate}
                      onClick={onClickToday}
                    >Hoy</button>

                    <div style={{ height: "50px", width: "2px", backgroundColor: "#E0E0E0", margin: "auto", marginLeft: "30px", marginRight: "30px" }} />
                  </div>

                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "60%" }}>
                    <div>
                      <label className={classes.labelDate} >Desde</label>
                      <TextField
                        type="date"
                        className={classes.inputDate}
                        onChange={onChangeDateOne}
                        style={{ width: '85%' }}
                        inputStyle={{ width: '85%' }}
                      />
                    </div>
                    <div>
                      <label className={classes.labelDate} >Hasta</label>
                      <TextField
                        type="date"
                        className={classes.inputDate}
                        onChange={onChangeDateTwo}
                        style={{ width: '85%' }}
                        inputStyle={{ width: '85%' }}
                      />
                    </div>
                    <button
                      className={classes.enableButtonDate}
                      onClick={onClickRange}
                    >Buscar</button>

                    <div style={{ height: "50px", width: "2px", backgroundColor: "#E0E0E0", margin: "auto", marginLeft: "30px", marginRight: "30px" }} />
                  </div>

                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "20%" }}>
                    <IconButton
                      onClick={onClickSave}
                      className={classes.enableButtonDate}
                    >
                      <Download style={{ marginRight: "8px" }} />
                      Descargar
                    </IconButton>
                  </div>
                </div>
              </div>

              <div id="tablePrint" style={{ alignItems: "center", justify: 'center', textAlign: "right", backgroundColor: "#fff", borderRadius: "4px", padding: '16px', width: "100%", height: "100%" }}>
                <Table style={{ marginBottom: "20px" }}>
                  <TableHead>
                    <TableRow className={classesTable.rootInvert} >
                      <TableCell size='small' padding='none' style={{ fontSize: "14px" }} >Fecha y hora</TableCell>
                      <TableCell size='small' padding='none' style={{ fontSize: "14px" }} >Concepto</TableCell>
                      <TableCell size='small' padding='none' style={{ fontSize: "14px" }} >Total</TableCell>
                      {/*{keys.map(key => (
                            <TableCell key={key}>{key}</TableCell>
                          ))}*/}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sales.map(({ id, name, creationDate, creationTime, total }) => (
                      <TableRow style={{ height: "20px" }} key={id}>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px" }} >{creationDate + " " + creationTime}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px" }} >{name}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px" }} >{currencyFormat(Number(total))}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <text className={classes.tableRowStyleSubTitleReportInvert} >{"Total: " + currencyFormat(Number(totalEgress))} </text>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default EgressReport;
